import axios from 'axios';
import { getApiBaseURL } from '../utils/site';

const service = axios.create({
  timeout: 30000,
});

service.interceptors.request.use((config) => {
  config.baseURL = process.env.REACT_APP_API_HOST || getApiBaseURL();
  return config;
});

service.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const msg = error.response?.data?.message || error.message || 'network error';
    return Promise.reject(new Error(msg));
  },
);

export default service;
